var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#001E64","d":"m12.821 0-2.387 2.563 7.11 7.625H0v3.624h17.544l-7.11 7.625L12.821 24 24 12z"}));
}

ArrowRight.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
